module.exports = __webpack_public_path__ + "img/ProspectCRM-second-splash.ce5dfe17.png";